import { FormViewerContext } from '@wix/form-viewer/widget';
import { type WidgetProps } from '@wix/yoshi-flow-editor';
import React, { type FC } from 'react';

import { type ControllerProps } from '../types';

import { Form } from './Form';

const Widget: FC<WidgetProps<ControllerProps>> = (props) => {
  return (
    <FormViewerContext {...props}>
      <Form {...props} />
    </FormViewerContext>
  );
};

export default Widget;
